/* eslint-disable @next/next/no-img-element */
import React from 'react';

import { useTranslation } from 'next-i18next';

import { Link } from '../../elements';
import { useBlogContext } from '../helpers';
import PopularPostsStyles from './PopularPosts.module.scss';

const PopularPosts = () => {
  const { t } = useTranslation('resources');
  const { topPosts } = t('blog', {
    returnObjects: true,
  }) as any;

  const blogContext = useBlogContext();
  const topPostsList = blogContext?.topPostsList || [];

  return (
    <div className={PopularPostsStyles.popularPostsWrapper}>
      <h3>{topPosts.title}</h3>
      <div className={PopularPostsStyles.posts}>
        {topPostsList.map((post, index) =>
          post.path ? (
            <Link className={PopularPostsStyles.post} to={post.path} title={post.title} key={index}>
              <img
                className={PopularPostsStyles.visual}
                src={post.img?.path || ''}
                alt={post.img?.alt || ''}
              />
              <p className={PopularPostsStyles.title}>{post.title}</p>
            </Link>
          ) : null
        )}
      </div>
    </div>
  );
};

export default PopularPosts;
